import { createContext } from 'react';

import { PhotoShootModel } from './types';

export type PhotoShootContextValue = {
  token: string | null;
  venueId: string;
  venueName?: string;
  images?: PhotoShootModel['images'];
  items?: PhotoShootModel['items'];
  status?: PhotoShootModel['status'];
  expiresIn?: PhotoShootModel['expiresIn'];
  hasEmployeeAccess: boolean;
};

const PhotoShootContext = createContext<PhotoShootContextValue>({
  venueId: '',
  token: null,
  hasEmployeeAccess: false,
});

export default PhotoShootContext;
